import { render } from "./MultiAnalysisModal.vue?vue&type=template&id=389cbe8c&scoped=true"
import script from "./MultiAnalysisModal.vue?vue&type=script&lang=js"
export * from "./MultiAnalysisModal.vue?vue&type=script&lang=js"

import "./MultiAnalysisModal.vue?vue&type=style&index=0&id=389cbe8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389cbe8c"]])

export default __exports__